module.exports = "/img/_/_/_/assets/images/creeper/battle/common//37.jpg?d4da5459902730e40e85d98767c7f774";